import React, { useMemo } from "react";
import styles from "./people.module.css";
import { Button, Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Portrait from "../../../../COMPONENTS/PORTRAIT";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { investigators } from "../../../../CONSTANTS/investigatorsList";
import adam from "../../../../ASSETS/IMAGES/BW_Adam_Maciak.png";
import roshni from "../../../../ASSETS/IMAGES/BW_Roshni-Dasgupta.png";
import jennifer from "../../../../ASSETS/IMAGES/BW_JenniferHilton.png";

const leaders = [
  { name: "Adam Maciak", role: "Chief Executive Officer and Founder", image: adam },
  { name: "Roshni Dasgupta", role: "Chief Financial Officer", image: roshni },
  { name: "Jennifer Hilton", role: "Senior Director of Operations", image: jennifer },
];

const asList = (v) => (Array.isArray(v) ? v : v ? [v] : []);

const People = () => {
  const featured = useMemo(
    () =>
      investigators
        .filter((i) => i.image && Number(i.numberOfClinicalTrail) > 0)
        .sort((a, b) => b.numberOfClinicalTrail - a.numberOfClinicalTrail)
        .slice(0, 8),
    []
  );

  return (
    <Section tone="light" id="people" labelledBy="people-title">
      <SectionIntro
        id="people-title"
        eyebrow="The people of KUR"
        title="Research is a human effort."
        lead="Leaders who built the network, and investigators who bring research to their own communities."
      />

      <div className={styles.leaders}>
        {leaders.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.1} className={styles.leader}>
            <Portrait src={p.image} alt={p.name} name={p.name} shape="tall" className={styles.portrait} />
            <h3 className={styles.name}>{p.name}</h3>
            <p className={styles.role}>{p.role}</p>
          </Reveal>
        ))}
      </div>

      <div className={styles.railHead}>
        <h3 className={styles.railTitle}>Investigators with the deepest trial experience</h3>
        <Button href="/network/doctors" variant="link" tone="light">
          Meet all investigators
        </Button>
      </div>
      <ul className={styles.rail} tabIndex={0} aria-label="Featured investigators">
        {featured.map((p) => (
          <li key={p.name} className={styles.card}>
            <Portrait src={p.image} alt={p.name} name={p.name} shape="arch" loading="eager" />
            <h4 className={styles.cardName}>{p.name}</h4>
            <p className={styles.cardMeta}>{asList(p.specialization).join(", ")}</p>
            <p className={styles.cardStat}>{p.numberOfClinicalTrail}+ trials</p>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default People;
